<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  import api from '@/api'
  import { mapState } from 'vuex'
  import { isMobile } from 'mobile-device-detect'
  import EventPreview from '@/components/layout/EventPreview'

  export default {
    name: 'ItemTemplate',
    components: {
      EventPreview,
    },
    props: {
      article: Object,
      // ToDo: is this ever be turned true? If not remove all code regarding this property
      commentsActive: Boolean,
      // ToDo: is this ever be turned true? If not remove all code regarding this property
      likesActive: Boolean,
    },
    data() {
      return {
        clampLinesTitle: this.exceptionalCustomers() ? 0 : 2,
        clampLines: this.exceptionalCustomers() ? 4 : isMobile ? 1 : 2,
        hoverLike: false,
        comments: {
          isPending: false,
          data: {},
        },
        likes: {
          isPending: false,
          data: {},
        },
      }
    },
    computed: {
      ...mapState('auth', ['settings']),
      getArticleImage() {
        const article = this.article
        if (article.images && article.images.teaser && article.images.teaser.link) {
          return article.images.teaser.link
        } else if (article.attachments && article.attachments[0] && article.attachments[0].link) {
          return article.attachments[0].link
        } else {
          return this.customerConfig.images.imagePlaceholder
        }
      },
    },
    created() {
      if (!Object.prototype.hasOwnProperty.call(this.article, 'likes_allowed') || this.article.likes_allowed) {
        this.fetchLikes()
      }
      if (this.article.comments_allowed) {
        this.fetchComments()
      }
    },
    methods: {
      toggleState(state) {
        state = !state
      },
      imageHeight() {
        return this.exceptionalCustomers() ? '100%' : 'auto'
      },
      async fetchComments() {
        this.toggleState(this.comments.isPending)
        api.items.getItems('comments', { type: 'news', id: this.article.id }).then(({ data }) => {
          this.comments.data = data
          this.toggleState(this.comments.isPending)
        })
      },
      async fetchLikes() {
        this.toggleState(this.likes.isPending)
        api.items.getItems('likes', { type: 'news', id: this.article.id }).then(({ data }) => {
          this.likes.data = data
          this.toggleState(this.likes.isPending)
        })
      },
      onLike(val) {
        this.toggleState(this.likes.isPending)
        api.items.editItem('likes', { type: 'news', id: this.article.id, like: val }).then(({ data }) => {
          this.likes.data = data
          this.toggleState(this.likes.isPending)
        })
      },
    },
  }
</script>
